import React from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import SocialButtons from "./SocialButtons";

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpMenu(filter: { slug: { eq: "top" } }) {
        nodes {
          menuItems {
            nodes {
              target
              url
              label
            }
          }
        }
      }
    }
  `);
  return (
    <header className='bg-dark'>
      <Container fluid='xl'>
        <Navbar bg='dark' sticky='top' variant='dark' expand='md'>
          <Link to='/' aria-label='Home'>
            <div className='logo'></div>
          </Link>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ml-auto sw-nav-menu'>
              {data.allWpMenu.nodes[0].menuItems.nodes.map(
                (menuItem, index) => {
                  return (
                    <Link key={index} to={menuItem.url} className='nav-link'>
                      <span>{menuItem.label}</span>
                    </Link>
                  );
                }
              )}
            </Nav>
            <SocialButtons />
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
